<script lang="ts">
	import { EditionsCheckoutContext } from '#lib/websites/editions/components/EditionsCheckoutContext/index.js';
	import { EditionsHeader } from '#lib/websites/editions/components/EditionsHeader/index.js';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
</script>

<EditionsCheckoutContext>
	<EditionsHeader>
		{@render children?.()}
	</EditionsHeader>
</EditionsCheckoutContext>
